import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { CoverageMap } from '../components/CoverageMap';
import { HorariosBanner } from '../components/HorariosBanner';
import { HowItWorks } from '../components/HowItWorks';
import { ComparisonTable } from '../components/ComparisonTable';
import { MenuSection } from '../components/MenuSection';
import { ReviewsCarousel } from '../components/ReviewsCarousel';
import { CallToAction } from '../components/CallToAction';
import { Footer } from '../components/Footer';

export const Home: React.FC = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <CoverageMap />
      <HorariosBanner />
      <HowItWorks />
      <ComparisonTable />
      <MenuSection />
      <ReviewsCarousel />
      <CallToAction />
      <Footer />
    </>
  );
};